import { AppSubjectEnum } from '../enums/app-subject.enum';

const CASL_SUBJECTS = new WeakMap<object, AppSubjectEnum>();

/**
 * Marks a DTO class with its CASL subject so `ability.can(action, instance)` can
 * resolve the subject type. Replaces the legacy `static get modelName()` pattern.
 */
export function CaslSubject(subject: AppSubjectEnum): ClassDecorator {
  return (target) => {
    CASL_SUBJECTS.set(target as unknown as object, subject);
  };
}

/**
 * Resolves the CASL subject for a class or an instance of a decorated class.
 */
export function getCaslSubject(target: unknown): AppSubjectEnum | undefined {
  if (target === null || target === undefined) {
    return undefined;
  }

  const ctor =
    typeof target === 'function'
      ? (target as object)
      : (target as object).constructor;

  return CASL_SUBJECTS.get(ctor);
}
